import graphql__4083353a1de4900f7a69 from "./__generated__/TitleBarWithAction_resource.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import PageTitle from "../Pages/PageTitle";
import { Desktop, NonDesktop, useResponsiveFlag } from "../Utils/ResponsiveQueries";
import StickyTitleBar from "../Utils/StickyTitleBar";
import FixedActionButton from "../FixedActions/FixedActionButton";

// This components allows displaying the generic participative module top bar with its
// associated information and actions, in a responsive way.
//
const TitleBarWithAction = ({ actionsCount = 1, sticky = true, ...props }) => {
  const resource = useFragment(TitleBarWithAction_resource, props.resource);
  const { action } = props;
  const { title } = resource;

  const { isDesktop, isNonDesktop } = useResponsiveFlag();

  const titleActionClassName = classNames(
    "col-lg-4",
    "two-cols-right-bar",
    "title-actions",
    { "title-actions-multi": actionsCount > 1 }
  );

  const TitleContainerComponent = sticky ? StickyTitleBar : DivTitleBar;
  const titleClassName = classNames({
    "title-bar-without-action": isNonDesktop || !action
  });
  const titleContainerClassName = classNames(props.className, {
    row: isDesktop && action
  });

  return (
    <TitleContainerComponent
      className={titleClassName}
      innerClassName={titleContainerClassName}
    >
      {action && (
        <Desktop>
          <div className="col-lg-8 two-cols-left-bar">
            <PageTitle page={resource} title={title} sticky={sticky} />
          </div>

          <div className={titleActionClassName}>{action}</div>
        </Desktop>
      )}

      {(!action || isNonDesktop) && <PageTitle page={resource} title={title} />}

      <NonDesktop>
        {actionsCount === 1 && <FixedActionButton>{action}</FixedActionButton>}
        {actionsCount > 1 && action}
      </NonDesktop>
    </TitleContainerComponent>
  );
};

// Simple div title bar component to allow switching from the StickyTitleBar component
// container to a simple <div> wrapper if the TitleBarWithAction is set not to be sticky
// because of a `sticky: false` prop.
//
const DivTitleBar = props => {
  const { innerClassName, children } = props;
  const className = classNames("padding-y-xs", props.className, innerClassName);

  return <div className={className}>{children}</div>;
};

const TitleBarWithAction_resource = graphql__4083353a1de4900f7a69;

export default TitleBarWithAction;
